import { serverPost } from "lib/serverRequest";

export const authLogin = ({ data = {}, onFinish = () => {} }) => {
  serverPost({ url: "login", data: data, onFinish: onFinish });
};

export const authRegister = ({ data = {}, onFinish = () => {} }) => {
  serverPost({ url: "register", data: data, onFinish: onFinish });
};
